export const environment = {
  env: 'PROD',
  production: true,
  // serverBaseUrl: 'https://agent-api.herokuapp.com',
  //serverUrl: 'https://agent-api.herokuapp.com/v1'
  // Live
  // serverBaseUrl: 'https://pip-api.nesna-resources.com',
  // serverUrl: 'https://pip-api.nesna-resources.com/v1',
  // s3Url: 'https://nesna-pip.s3.amazonaws.com',
  // siteKey: '6LcHBxAcAAAAAM5lFam36od_3C_HN4jsL8gxaejL',
  // devServiceURL: 'https://devservices.dowc.com',
  // appsURL: 'https://apps.nesna-resources.com',
  //UAT
  serverBaseUrl: 'https://uat-pip-api.nesna-resources.com',
  serverUrl: 'https://uat-pip-api.nesna-resources.com/v1',
  s3Url: 'https://uat-nesna-pip.s3.amazonaws.com',
  siteKey: '6LcHBxAcAAAAAM5lFam36od_3C_HN4jsL8gxaejL',
  devServiceURL: 'https://devservices.dowc.com',
  appsURL: 'https://uat-apps.nesna-resources.com',

  logoURL:'https://nesna-assets.s3.us-east-1.amazonaws.com/nissan/Nissan-NESNA-Logo_white.png',
  favIcon:'https://dowc-assets.s3.us-east-1.amazonaws.com/Nissan-Fav+1.png',
  primaryColor:'#000',
  secondaryColor:'#4c4a4a',
};
